export default __webpack_public_path__ + "static/media/Lm.7d79f58f.jpg";